module.exports = __webpack_public_path__ + "img/11.46871b59.jpg";